import React from 'react';
import ModalContent from './ModalContent.js';
import Container from '../../Container.js';
import ModalBodyActions from './ModalBodyActions.js';
import ModalBodyText from './ModalBodyText.js';
const ModalPredefinedInfo = ({
  headline,
  line1,
  line2,
  primaryButton = 'OK',
  dispatchHide
}) => {
  const bodyClassNames = 'ebds-modal__content__body';
  return /*#__PURE__*/React.createElement(ModalContent, {
    type: "info"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: bodyClassNames
  }, /*#__PURE__*/React.createElement(ModalBodyText, {
    headline: headline,
    line1: line1,
    line2: line2
  }), /*#__PURE__*/React.createElement(ModalBodyActions, {
    primaryButton: primaryButton,
    onPrimary: dispatchHide
  }))));
};
export default ModalPredefinedInfo;